<template>
  <div :class="[{'chat-iframe-full':is_full_d}]" class="chat-iframe" v-if="is_show_d">
    <div class="chat-iframe-top">
      <!-- <a href="javascript:void(0);" @click="is_full_d = !is_full_d">
        <img v-show="!is_full_d" class="full-icon" src="@/assets/images/html/icon/full.png"/>
        <img v-show="is_full_d" class="full-icon" src="@/assets/images/html/icon/out_full.png"/>
      </a>-->
      <a @click="close()" class="close" href="javascript:void(0);">X</a>
    </div>
    <iframe
      :src="$getOldWebUrl()+link"
      frameborder="0"
      height="100%"
      scrolling="auto"
      style="display: inherit; margin:auto;"
      width="100%"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'Chat',
  componentName: "Chat",
  data () {
    return {
      src: this.url,
      is_full_d: this.is_full,
      is_show_d: this.value
    }
  },
  props: {
    url: String,
    //是否全屏
    is_full: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    url (value) {
      this.src = value
    },
    value (value) {
      this.is_show_d = value
    }
  },
  created () {
    if (!this.src) {
      this.src = 'chat/chat.jsp'
    }
  },
  computed: {
    link () {
      if (this.src.indexOf('?') != -1) {
        return this.src + '&is_show_msgnum=1'
      } else {
        return this.src + '?is_show_msgnum=1'
      }
    }
  },
  methods: {
    close () {
      this.is_full_d = false
      this.is_show_d = false
      this.$emit('input', false) // 触发 input 事件
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/common/chat.vue